// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"RankingTimer_loaderContainer__2r-tr","loader":"RankingTimer_loader__3j4tW","timer":"RankingTimer_timer__2KFDK"};